import React from 'react'
import AssetDetails from '../PureComponent/AssetDetails'

const RenderAssetDetails = () => {
  return (
   <AssetDetails/>
  )
}

export default RenderAssetDetails